import { get } from '@ember/object';

import { load } from 'ember-async-data';

import Component from 'umg-ember-backend/components/record-detail/forms';
import ContentWithSidebar from 'umg-ember-backend/components/ui/content-with-sidebar';
import Form from 'umg-ember-backend/components/ui/form';
import Loader from 'umg-ember-backend/components/ui/loader';
import { labelValueOptions } from 'umg-ember-backend/utils/intl';

export default class RecordDetailFormsContestEntryComponent extends Component {
  // Defaults
  status = [1, 2, 3, 4, 5];

  // Getters and setters
  get statusOptions() {
    return labelValueOptions.call(this, this.status, [
      'forms.contest-entry.options.status',
    ]);
  }

  get formFields() {
    return this.args.model.contest.then(
      (contest: Awaited<typeof this.args.model.contest>) => contest?.formFields,
    );
  }

  // Template
  <template>
    <Form @model={{@model}} @showErrors={{@showErrors}} as |form|>
      <ContentWithSidebar>
        <:content>
          <form.fieldset @titleKey='general' as |fieldset|>
            <fieldset.field @property='email' />
            {{#let (load this.formFields) as |result|}}
              {{#if result.isResolved}}
                {{#if result.value}}
                  <table class='o-table'>
                    <tbody class='o-table__body'>
                      {{#each result.value as |field|}}
                        <tr class='o-table__row'>
                          <td class='o-table__cell'>{{field.label}}</td>
                          <td class='o-table__cell'>{{get
                              @model.data
                              field.id
                            }}</td>
                        </tr>
                      {{/each}}
                    </tbody>
                  </table>
                {{/if}}
              {{else if result.isPending}}
                <Loader @isWaiting={{true}} />
              {{/if}}
            {{/let}}
          </form.fieldset>
        </:content>
        <:sidebar>
          <form.fieldset @titleKey='settings' as |fieldset|>
            <fieldset.field
              @property='contest'
              @disabled={{true}}
              @type='belongs-to'
            />
            <fieldset.field
              @property='status'
              @type='select-value'
              @options={{this.statusOptions}}
            />
          </form.fieldset>
          <form.sections.meta />
        </:sidebar>
      </ContentWithSidebar>
    </Form>
  </template>
}
